import { render, staticRenderFns } from "./EmailTemplateType.vue?vue&type=template&id=48961ecc&scoped=true&"
import script from "./EmailTemplateType.vue?vue&type=script&lang=js&"
export * from "./EmailTemplateType.vue?vue&type=script&lang=js&"
import style0 from "./EmailTemplateType.vue?vue&type=style&index=0&id=48961ecc&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48961ecc",
  null
  
)

export default component.exports